export enum ClaimPackageIssue {
    NOT_DELIVERED = 'not_delivered',
    TO_INCORRECT_ADDRESS = 'incorrect_address',
    NO_SCAN = 'no_scan'
}
